import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  container: {
    marginBottom: theme.spacing(3),
  },
  content: {
    display: 'flex',
    alignItems: 'center',
  },
  logoContainer: {
    width: 80,
    height: 80,
    marginRight: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    width: '100%',
    height: '100%',
  },
  label: {
    fontSize: 12,
    marginBottom: theme.spacing(1),
    color: '#90A4AE',
  },
  button: {
    borderColor: theme.palette.colors.teal,
  },
}));



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentSettingsPage/components/ProfileForm/components/CompanyLogo/useStyles.js